import { LOCAL_STORAGE_KEYS } from './shared-constants';
import {
    UserInfo, LastClickedSymbol, ClientMessagesStorageInterface, UserBook, SelectedMarketWatch, ServerUrls, ClientIpoSectionState, PanVerifyRequestResponse, totpUserInfo,
    ActiveTab
} from '../app.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class StorageHelper {

    constructor() { }

    get(key: string) {
        if (localStorage.getItem(key)) {
            return JSON.parse(localStorage.getItem(key));
        }
    }

    set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    get userInfo(): UserInfo {
        return this.get(LOCAL_STORAGE_KEYS.userInfo);
    }
    set userInfo(userInfo: UserInfo) {
        this.set(LOCAL_STORAGE_KEYS.userInfo, userInfo);
    }

    get totpUserInfo(): totpUserInfo {
        return this.get(LOCAL_STORAGE_KEYS.totpUserInfo);
    }
    set totpUserInfo(userInfo: totpUserInfo) {
        this.set(LOCAL_STORAGE_KEYS.totpUserInfo, userInfo);
    }

    get userBook(): UserBook {
        return this.get(LOCAL_STORAGE_KEYS.userBook);
    }
    set userBook(userBook: UserBook) {
        this.set(LOCAL_STORAGE_KEYS.userBook, userBook);
    }

    get activeTab(): ActiveTab {
        return this.get(LOCAL_STORAGE_KEYS.activeTab);
    }
    set activeTab(tab: ActiveTab) {
        this.set(LOCAL_STORAGE_KEYS.activeTab, tab);
    }

    set serverUrls(server: ServerUrls) {
        this.set(LOCAL_STORAGE_KEYS.urls, server);
    }

    get serverUrls() {
        return this.get(LOCAL_STORAGE_KEYS.urls);
    }

    get selectedMarketWatch(): SelectedMarketWatch {
        return this.get(LOCAL_STORAGE_KEYS.selectedMarketWatch);
    }
    set selectedMarketWatch(selectedMarketWatch: SelectedMarketWatch) {
        this.set(LOCAL_STORAGE_KEYS.selectedMarketWatch, selectedMarketWatch);
    }


    get lastClickedSymbol(): LastClickedSymbol {
        return this.get(LOCAL_STORAGE_KEYS.lastClickedSymbol);
    }

    set lastClickedSymbol(lastClickedSymbol: LastClickedSymbol) {
        this.set(LOCAL_STORAGE_KEYS.lastClickedSymbol, lastClickedSymbol);
    }

    get logMessages(): ClientMessagesStorageInterface {
        return this.get(LOCAL_STORAGE_KEYS.messages);
    }

    set logMessages(messagesData: ClientMessagesStorageInterface) {
        this.set(LOCAL_STORAGE_KEYS.messages, messagesData);
    }

    get appLogLevel() {
        return localStorage.getItem(LOCAL_STORAGE_KEYS.logLevel);
    }

    get edisRequired() {
        return this.get(LOCAL_STORAGE_KEYS.edisRequired);
    }

    set edisRequired(require: any) {
        this.set(LOCAL_STORAGE_KEYS.edisRequired, require);
    }

    get IPOsExpanded(): ClientIpoSectionState {
        return this.get(LOCAL_STORAGE_KEYS.ipoExpandedId);
    }

    set IPOsExpanded(data: ClientIpoSectionState) {
        this.set(LOCAL_STORAGE_KEYS.ipoExpandedId, data);
    }

    get tempUserInfo(): PanVerifyRequestResponse {
        return this.get(LOCAL_STORAGE_KEYS.tempUserInfo);
    }

    set tempUserInfo(data) {
        this.set(LOCAL_STORAGE_KEYS.tempUserInfo, data);
    }

    get nextParam(): string {
        return this.get(LOCAL_STORAGE_KEYS.nextParam);
    }

    set nextParam(nextParam) {
        this.set(LOCAL_STORAGE_KEYS.nextParam, nextParam);
    }

    clearNextParam() {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.nextParam);
    }

    clear() {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.userInfo);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.totpUserInfo)
        localStorage.removeItem(LOCAL_STORAGE_KEYS.lastClickedSymbol);
    }

    clearTempInfo() {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.tempUserInfo);
    }
}
